import { URL_SYNCED_PARAMS } from '../configs/constants';

export const updateCurrentPath = (filters) => {
  const searchParams = new URLSearchParams(window.location.search);

  URL_SYNCED_PARAMS.forEach((paramName) => {
    const value = filters[paramName];

    if (value || value === 0) {
      searchParams.set(paramName, value);
    } else {
      searchParams.delete(paramName);
    }
  });

  const query = searchParams.toString();
  const nextUrl = window.location.pathname + (query ? `?${query}` : '');

  window.history.replaceState(null, '', nextUrl);
};
